import { atom } from 'jotai';
import { StrapiSiteConfig } from '../../../core/models/strapi-site-config.model';

const siteConfigAtom = atom<StrapiSiteConfig | null>(null);

export { siteConfigAtom };
